import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Media } from '@api/backend';

export const userMediaAdapter: EntityAdapter<Media> = createEntityAdapter<Media>({
  selectId: (media) => media.media_id,
});


export interface UserMediaState extends EntityState<Media> {
  nextPageToken: string | null | undefined;
  isLoading: boolean;
}

export const initialUserMediaState = userMediaAdapter.getInitialState({
  nextPageToken: undefined,
  isLoading: false,
});
